module.exports = __webpack_public_path__ + "img/gameTronos4.113d0580.jpg";